import React, { useMemo } from "react";
import clsx from "clsx";
import { IItemOrcamento } from "../../../types/IItemOrcamento";
import { ItemConsultaItens } from "./ItemConsultaItens";
import { RespostaConsultaItensOrcamento } from "app/types/orcamento/consultaItens/RespostaConsultaItensOrcamento";
import { AcoesHead } from "../grid-itens/head/AcoesHead";
import { IColuna } from "app/types/IColuna";
import { traduzirNomeColuna } from "app/utils/UtilsColunas";

const estilosTabelas = require('../../../estilos/tabelas.module.scss').default;
const estilosConsultaitens = require('./consultaItens.module.scss').default;


export type ConsultaItensProps = {
    rotuloColunaCodigoReferencia: "CODIGO" | "REFERENCIA",
    numeroCasasDecimaisQuantidade: number,
    numeroCasasDecimaisPreco: number,
    dadosOrcamento: RespostaConsultaItensOrcamento,
    codigoFilialOrcamento: string,
    corPorAmbiente: { [ambiente: string]: string },
    colunas: IColuna[],
    tamanhoFonte: number,
    permiteEngrenagemGrid: boolean,
    parametro_CHAVE_MOVIMENTACAO_ORCAMENTO: "C" | "R",
    onToggleColunaSelecionada: (nomeColuna: string, selecionada: boolean) => void,
    onToggleSelecionarTodasColunas: (selecionar: boolean) => void
}

export const ConsultaItens = React.memo((props: ConsultaItensProps) => {

    const colunasSelecionadas = useMemo(() => props.colunas.filter(coluna => coluna.Selecionada), [props.colunas]);

    return <>
        {/* A barra de ações fica FORA da área rolável: assim não anda junto quando a grade rola na
            horizontal (nem sobe quando rola na vertical). Por isso também não recebe mais
            `larguraLinha` — antes ela era esticada até a largura da tabela para acompanhar a
            rolagem; agora ocupa 100% da largura visível, que é o padrão do AcoesHead. */}
        <AcoesHead
            id="AcoesHeadConsultaItens"
            codigoFilialOrcamento={props.codigoFilialOrcamento}
            colunas={props.colunas}
            onToggleColunaSelecionada={props.onToggleColunaSelecionada}
            onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
            tamanhoFonte={props.tamanhoFonte}
            exibirIconesAumentarDiminuirFonte={false}
            nomeGrid="CONSULTAR_ITENS_ORCAMENTO"
            rotuloColunaCodigoReferencia={props.rotuloColunaCodigoReferencia}
            parametro_CHAVE_MOVIMENTACAO_ORCAMENTO={props.parametro_CHAVE_MOVIMENTACAO_ORCAMENTO}
            permiteEngrenagemGrid={props.permiteEngrenagemGrid ?? false}
        />

        <div className={estilosConsultaitens.areaRolavel}>
            <table className={clsx(estilosTabelas.tabela, estilosConsultaitens.tabelaFixa)} style={{ marginRight: '10px' }}
                id="ConsultaItens_Tabela"
            >
                <thead
                    id="ConsultaItens_Tabela_Head"
                >
                    <tr
                        id="ConsultaItens_Tabela_Head_Linha"
                    >
                        {colunasSelecionadas.map((coluna, key) => (
                            <th key={key}
                                id={`ConsultaItens_Tabela_Head_${coluna.Nome}`}
                            >
                                {traduzirNomeColuna({
                                    nomeColuna: coluna.Nome,
                                    codigoFilialOrcamento: props.codigoFilialOrcamento,
                                    nomeGrid: "CONSULTAR_ITENS_ORCAMENTO",
                                    codigoOuReferencia: props.rotuloColunaCodigoReferencia
                                })}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {props.dadosOrcamento.Itens.map(item => (
                        <ItemConsultaItens
                            key={item.Index}
                            item={item}
                            numeroCasasDecimaisQuantidade={props.numeroCasasDecimaisQuantidade}
                            numeroCasasDecimaisPreco={props.numeroCasasDecimaisPreco}
                            corPorAmbiente={props.corPorAmbiente}
                            colunasSelecionadas={colunasSelecionadas}
                        />
                    ))}
                </tbody>
            </table>
        </div>
    </>
});
